module.exports = __webpack_public_path__ + "img/gala-situation.69cb40e8.svg";